import { ICDAuxCheckboxModel } from "./icd-aux-checkbox.model";

let NEXT_INSTANCE_ID = 1;
export abstract class ICDBaseModel {
  public abstract auxModel: ICDAuxCheckboxModel;
  public disabled: boolean = false;

  private _nulledByDependency: boolean = false;

  private instanceId: number;

  constructor() {
    this.instanceId = NEXT_INSTANCE_ID++;
  }

  public abstract get value(): any;
  public abstract set value(_val: any);

  public get nulledByDependency(): boolean {
    return this._nulledByDependency;
  }
  public set nulledByDependency(value: boolean) {
    if (this._nulledByDependency != value) {
      this._nulledByDependency = value;
    }
  }
}
